(ns minorodata.json-flattening.api
  (:require [mold-http.core :refer [reg-event-http]]
            [minorodata.app.handlers :refer [reg-event-fx dispatch]]
            [re-posh.core :as re-posh]
            [minorodata.app.config :refer [slow-query-duration-s]]
            [minorodata.app.utils :as app.utils]
            [minorodata.json-flattening.model :refer [->json-flattening]]))


(defn fetch-columns-request [_ [table]]
  {:http-xhrio
   {:id  :json-flattening-columns-fetch-request
    :url "/api/table-column-tree"
    :params {:table-name table}}})


(defn fetch-columns-callback [_ [error resp]]
  (if (some? error)
    {:dispatch-n [[:json-flattening/update (->json-flattening
                                            {:show-select-table? true
                                             :selected-table {}})]
                  [:app.events/add-snack :error "Failed to fetch columns data"]
                  [:app.api/log :error "Failed to load columns data" error]]}
    {:dispatch [:json-flattening/update (->json-flattening {:structure resp})]}))


(reg-event-http
  :json-flattening.api/fetch-columns
  fetch-columns-request
  fetch-columns-callback)


(defn fetch-sql-request [_ [params]]
  (let [{:keys [structure columns config]} params
        json-structure (:json-structure structure)
        ;; Sometimes data-type is absent for some reason
        json-structure (map (fn [col]
                              (let [data-type (:data-type col)]
                                (assoc col :data-type (or data-type "text"))))
                            json-structure)
        structure (assoc structure :json-structure json-structure)]

    (when-not (empty? columns)
      {:http-xhrio
       {:id  :json-flattening-sql-fetch-request
        :url "/api/table-column-tree/transform"
        :method :post
        :params (assoc structure
                       :destination-schema-name ""
                       :destination-table-name ""
                       :column-selection (map-indexed (fn [idx c]
                                                        (let [overrides (get config c)]
                                                          (if overrides
                                                            (let [{:keys [name data-type]} overrides]
                                                              {:key-id c
                                                               :sort_order idx
                                                               :data_type (or data-type "text")
                                                               :alias name})
                                                            {:key-id c
                                                             :sort_order idx})))
                                                      columns))}})))


(defn fetch-sql-callback [_ [error resp]]
  (if (some? error)
    {:dispatch-n [[:app.api/log :error "Failed to generate sql" error]
                  [:json-flattening/update (->json-flattening {:error (get-in error [:response :error])})]]}
    {:dispatch [:json-flattening/update (->json-flattening {:error ""
                                                            :code (:query resp)
                                                            :data {:preview (rest (:preview resp))
                                                                   :columns (first (:preview resp))}})]}))


(reg-event-http
  :json-flattening.api/fetch-sql
  fetch-sql-request
  fetch-sql-callback)
